(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/components/scroll-to-top.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/components/scroll-to-top.js');
"use strict";


const {
  useEffect
} = React;
const {
  useLocation
} = ReactRouterDOM;
setGlobal('svs.ticketsValidateManual.components.ScrollToTop', () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
});

 })(window);